export default "__VITE_ASSET__CG9Op$6M__"